import { rsBranding } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://www.rosettastone.fr/magazine/",
        external: true,
        new_window: true,

        // Labels
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,

        // Labels
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            asset_static: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,

        // Labels
        destination: "tel:18007673882",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,

        // Labels
        language_options_featured: [
            {
                url: "/l-anglais/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/le-japonais/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/l-allemand/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/le-francais/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/l-espagnol/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/l-italien/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/l-arabe/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/le-chinois/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/le-neerlandais/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/l-anglais-americain/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            },
            {
                url: "/le-filipino/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/le-grec/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/l-hebreu/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/l-hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/l-irlandais/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/le-coreen/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            // {
            //     url: "/buy-latin/",
            //     title: strings.locale_la_va_label_primary,
            //     small: strings.locale_la_va_label_secondary
            // },
            {
                url: "/le-farsi/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/le-polonais/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/le-portugais/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/le-russe/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/l-espagnol-d-amerique-latine/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/le-suedois/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/le-turc/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/le-vietnamien/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],

        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: false,
        destination: "https://espanol.rosettastone.com/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/fr/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/ecoles-primaires-secondaires/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/education-superieure/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/entreprises/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_enterprise_label
    }
});
